import React, { useState, useEffect, useContext } from "react";
import { mercadoPagoPreference } from "../../actions/home";
import { CartContext } from "../../contexts/CartContext";
import { enviarCarrito } from "../../actions/home";
import { FormContext } from "../../contexts/FormContext";
import Swal from "sweetalert2";

export const MercadoPagoWallet = () => {
    const [initPoint, setInitPoint] = useState(null)
    const [errorFrm, setErrorFrm] = useState(false)
    const { cartItems, cartSummary } = useContext(CartContext);
    const { subtotal, descuentoCupon, costoTotal, cantidades } = cartSummary;
    const { formData, updateField } = useContext(FormContext);
    //console.log('formDatax context',formData)
    const {
        nombre,
        apellidos,
        email,
        dni,
        ruc,
        telefono,
        departamento,
        provincia,
        distrito,
        tipoDocumento,
        tipoEntrega,
        tipoDireccion,
        direccion,
        direccionReferencia
    } = formData



    useEffect(() => {

        console.log("🧾 formData completo:", formData);

        const fetchPreference = async () => {
            const campos = [
                nombre,
                apellidos,
                email,
                dni,
                ruc,
                telefono,
                departamento,
                provincia,
                distrito,
                tipoDocumento,
                tipoEntrega,
                // tipoDireccion,
                // direccion,
                // direccionReferencia,
            ];

            if (tipoEntrega === "domicilio") {
                campos.push(
                    tipoDireccion,
                    direccion,
                    direccionReferencia
                );
            }

            console.log("🧾 Valores del formulario:");
            campos.forEach((campo, i) => {
                console.log(`Campo ${i}:`, campo);
            });

            const hayCampoVacio = campos.some(campo => !campo || campo.trim() === '');
            //console.log('hayCampoVaciox',hayCampoVacio)
            setErrorFrm(hayCampoVacio);

            console.log("❓ ¿Hay campo vacío?", hayCampoVacio);

            const cartContext = { cartItems, cantidades, subtotal, descuentoCupon, costoTotal };
            const carritoResponse = await enviarCarrito(cartContext);

            if (carritoResponse && carritoResponse.resumen) {
                const totalSinDescuento = parseFloat(subtotal) || 0;
                const totalConDescuento = parseFloat(costoTotal) || 0;

                // console.log('🧾 subtotal (totalSinDescuento):', subtotal, typeof subtotal);
                // console.log('💰 costoTotal (totalConDescuento):', costoTotal, typeof costoTotal);


                const productos = cartItems.map(item => {
                    const cantidad = item.cantidad;
                    const precioUnitarioOriginal = parseFloat(item.productoPrecio);

                    // console.log('🧾 Item del carrito:', item);
                    // console.log('🔢 Precio original:', item.productoPrecio, '| Después de parseFloat:', precioUnitarioOriginal);
                    // console.log('🧮 Cantidad:', cantidad);

                    const subtotalItem = precioUnitarioOriginal * cantidad;
                    // console.log('📦 subtotalItem:', subtotalItem, '| totalSinDescuento:', totalSinDescuento);


                    // Aplicar descuento proporcional al item
                    const porcentaje = subtotalItem / totalSinDescuento;
                    const subtotalItemConDescuento = porcentaje * totalConDescuento;
                    const nuevoPrecioUnitario = subtotalItemConDescuento / cantidad;

                    // console.log('💸 Nuevo precio unitario:', nuevoPrecioUnitario);

                    return {
                        id: item.productoId,
                        title: `Compra de ${cartItems.length} producto(s) en elbuenloot`,
                        quantity: cantidad,
                        description: item.productoNombre,
                        unit_price: parseFloat(nuevoPrecioUnitario), // Math.floor(nuevoPrecioUnitario * 100) / 100
                        currency_id: 'PEN'
                    };
                });

                const payer = {
                    name: nombre,
                    surname: apellidos,
                    email: email,
                    phone: {
                        area_code: "51",
                        number: telefono
                    },
                    identification: {
                        type: tipoDocumento,
                        number: tipoDocumento === "dni" ? dni : ruc,
                    },
                    address: {
                        zip_code: tipoEntrega,
                        street_name: departamento + '-' + provincia + '-' + distrito,
                        // street_number: tipoDireccion,
                    },
                    date_created: new Date()
                }   

                const shipments = {
                    local_pickup: false,
                    dimensions: '',
                    cost: 0,
                    receiver_address: {
                        city_name: distrito,
                        state_name: provincia,
                        apartment: departamento,
                        country_name: 'Peru'
                    }
                }

                const preference = await mercadoPagoPreference({ productos, payer, shipments });

                if (preference && preference.init_point && !hayCampoVacio) {
                    setInitPoint(preference.init_point);
                }
                //console.log('errorFrmx',errorFrm)
            }
        };
        if (cartItems.length > 0) {
            fetchPreference();
        }
    }, [formData]);
    const handleFinalizar = () => {
        /*if(initPoint) {
            window.open(initPoint, '_blank', 'noopener,noreferrer');
        }*/

        Swal.fire({
            position: "center",
            icon: "error",
            title: "Falta completar el formulario, revise por favor",
            showConfirmButton: false,
            timer: 2500,
            customClass: {
                container: 'custom-body'
            }
        });


        return false
    }
    return (
        <div>
            {initPoint && !errorFrm && (
                <a
                    //href={initPoint}
                    href={initPoint}
                    // target="_blank"
                    rel="noopener noreferrer"
                    className="color-blanco txt-semibold font15 font16-5 font-family-montserrat"
                    style={{
                        display: 'inline-block',
                        backgroundColor: '#1B09E8',
                        padding: '15px 30px',
                        borderRadius: '8px',
                        textDecoration: 'none',
                        textAlign: 'center',
                        cursor: 'pointer'
                    }}
                >
                    Finalizar compra
                </a>
            )}

            {
                (errorFrm && cartItems.length > 0) ?

                    <a
                        //href={initPoint}
                        onClick={handleFinalizar}
                        //href={initPoint}
                        // target="_blank"
                        rel="noopener noreferrer"
                        className="color-blanco txt-semibold font15 font16-5 font-family-montserrat"
                        style={{
                            display: 'inline-block',
                            backgroundColor: '#1B09E8',
                            padding: '15px 30px',
                            borderRadius: '8px',
                            textDecoration: 'none',
                            textAlign: 'center',
                            cursor: 'pointer'
                        }}
                    >
                        Finalizar compra
                    </a>
                    : ''
            }


        </div>
    );
};
